var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57632 1.80554H5.73585C5.50183 1.80554 5.31226 1.61597 5.31226 1.38195V1.11842C5.31226 0.8844 5.50183 0.694824 5.73585 0.694824H9.57632C9.80999 0.694824 9.99957 0.8844 9.99957 1.11807V1.38299C9.99957 1.61666 9.80999 1.80624 9.57632 1.80624V1.80554Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57632 9.30524H5.73585C5.50183 9.30524 5.31226 9.11566 5.31226 8.88164V8.61811C5.31226 8.3841 5.50183 8.19452 5.73585 8.19452H9.57632C9.80999 8.19452 9.99957 8.38409 9.99957 8.61777V8.88269C9.99957 9.11636 9.80999 9.30593 9.57632 9.30593V9.30524Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22001 0.00352134C2.68948 -0.0357132 2.22283 0.256636 2.00548 0.694466H0.423247C0.189576 0.694466 0 0.884042 0 1.11771V1.38263C0 1.6163 0.189576 1.80588 0.423247 1.80588H2.00548C2.20998 2.21732 2.63462 2.5003 3.12522 2.5003C3.84568 2.5003 4.42378 1.89095 4.37205 1.15938C4.3283 0.545861 3.83318 0.0490056 3.22001 0.00352134Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22001 7.50322C2.68948 7.46398 2.22283 7.75633 2.00513 8.19416H0.423247C0.189576 8.19416 0 8.38374 0 8.61741V8.88233C0 9.116 0.189576 9.30558 0.423247 9.30558H2.00548C2.20998 9.71702 2.63462 9.99999 3.12522 9.99999C3.84568 9.99999 4.42378 9.39064 4.37205 8.65907C4.32865 8.04556 3.83353 7.5487 3.22036 7.50356L3.22001 7.50322Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84479 3.7534C8.31425 3.71416 7.84761 4.00651 7.63025 4.44434H0.423247C0.189576 4.44434 0 4.63392 0 4.86759V5.13251C0 5.36618 0.189576 5.55576 0.423247 5.55576H7.63025C7.83476 5.9672 8.25939 6.25018 8.75 6.25018C9.47046 6.25018 10.0486 5.64082 9.99683 4.90926C9.95343 4.29574 9.45831 3.79888 8.84514 3.75375L8.84479 3.7534Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionIcon);
export default __webpack_public_path__ + "static/media/OptionIcon.f9cb2d4f63c82b5a7b0d2e3e53b40171.svg";
export { ForwardRef as ReactComponent };